import { FC, useEffect, useState } from 'react';

import BusinessButton from '../business-button/business-button';
import { COLOR, POSITION } from '../business-button/business-button.constants';
import styles from './business-hub-platform-integrations.module.scss';
import { useWindowSize } from '../../hook/useWindowSize';

export interface HeroPlatFormIntegrationsProps {
    background?: {
        backgroundColor: string;
        backgroundGradian: string;
        backgroundImage: string;
    };

    content?: {
        title?: string;
        description?: string;
        ctaText?: string;
        ctaLink?: string;
        backgroundButton?: COLOR;
        image?: string;
        imageMobile?: string;
    };
}

const BusinessHubPlatFormIntegrations: FC<HeroPlatFormIntegrationsProps> = (props) => {
    const { background, content } = props;

    const { width = 0 } = useWindowSize();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (width < 998) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [width]);

    return (
        <div
            className={styles.container}
            style={{
                backgroundColor: background?.backgroundColor,
            }}
        >
            <div className={styles.wrapperContent}>
                <div className={styles.content}>
                    <div className={styles.title} dangerouslySetInnerHTML={{ __html: content?.title || '' }}></div>

                    <div className={styles.description} dangerouslySetInnerHTML={{ __html: content?.description || '' }}></div>

                    {content?.ctaText && (
                        <div className={styles.button}>
                            <BusinessButton position={POSITION.LEFT} color={content?.backgroundButton} link={content?.ctaLink} buttonText={content?.ctaText} autoMargin={false}></BusinessButton>
                        </div>
                    )}
                </div>
            </div>

            {background?.backgroundImage && (
                <div className={styles.backgroundImage}>
                    <img src={background?.backgroundImage || ''} alt=""></img>
                </div>
            )}
            {content?.image && (
                <div className={styles.imageContent}>
                    <div className={styles.wrapperImage}>
                        <img src={(isMobile && content.imageMobile ? content.imageMobile : content?.image) || ''} alt=""></img>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BusinessHubPlatFormIntegrations;
